import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import ReactionList from './components/ReactionList';
import Search from './components/Search';
import ReactionDetail from './components/ReactionDetail';
import Stats from './components/Stats';
import Triage from './components/Triage';
import NewReaction from './components/NewReaction';
import EditHub from './components/EditHub';
import ReactionTypes from './components/ReactionTypes';
import PasswordGate from './components/PasswordGate';
import InnBrowse from './components/InnBrowse';
import InnDetail from './components/InnDetail';
import PipelineLayout from './pipeline/PipelineLayout';
import PipelinePage from './pipeline/pages/PipelinePage';
import ProgramDetail from './pipeline/pages/ProgramDetail';
import CompaniesPage from './pipeline/pages/CompaniesPage';
import CompanyDetail from './pipeline/pages/CompanyDetail';
import IndicationsPage from './pipeline/pages/IndicationsPage';
import ChangesPage from './pipeline/pages/ChangesPage';
import './App.css';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const isPipeline = location.pathname.startsWith('/pipeline');
  const isINN = location.pathname.startsWith('/inn');
  const isPhotochem = !isINN && !isPipeline;

  return (
    <nav className="navbar">
      <div className="nav-container">

        {/* Section bubbles */}
        <div className="nav-sections">
          <button
            className={`nav-section-btn photochem ${isPhotochem ? 'active' : ''}`}
            onClick={() => navigate('/')}
          >
            <span className="section-icon">⚗️</span>
            Photochemistry
          </button>
          <button
            className={`nav-section-btn who-inn ${isINN ? 'active' : ''}`}
            onClick={() => navigate('/inn')}
          >
            <span className="section-icon">💊</span>
            WHO-INN
          </button>
          <button
            className={`nav-section-btn pipeline-radar ${isPipeline ? 'active' : ''}`}
            onClick={() => navigate('/pipeline')}
          >
            <span className="section-icon">📡</span>
            Pipeline Radar
          </button>
        </div>

        {/* Sub-tabs — only for Photochemistry section */}
        {isPhotochem && (
          <ul className="nav-menu">
            <li><Link to="/"       className="nav-tab">Browse</Link></li>
            <li><Link to="/search" className="nav-tab">Search</Link></li>
            <li><Link to="/edit"   className="nav-tab">Edit</Link></li>
          </ul>
        )}

      </div>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/"                      element={<ReactionList />} />
          <Route path="/search"                element={<Search />} />
          <Route path="/reaction/:id"          element={<ReactionDetail />} />
          <Route path="/stats"                 element={<Stats />} />
          <Route path="/triage"                element={<PasswordGate><Triage /></PasswordGate>} />
          <Route path="/new"                   element={<PasswordGate><NewReaction /></PasswordGate>} />
          <Route path="/edit"                  element={<PasswordGate><EditHub /></PasswordGate>} />
          <Route path="/edit/reaction/:id"     element={<PasswordGate><ReactionDetail editable /></PasswordGate>} />
          <Route path="/edit/reaction-types"   element={<PasswordGate><ReactionTypes /></PasswordGate>} />
          <Route path="/inn"                   element={<InnBrowse />} />
          <Route path="/inn/:id"               element={<InnDetail />} />
          <Route path="/pipeline" element={<PipelineLayout />}>
            <Route index                       element={<PipelinePage />} />
            <Route path="programs/:id"         element={<ProgramDetail />} />
            <Route path="companies"            element={<CompaniesPage />} />
            <Route path="companies/:id"        element={<CompanyDetail />} />
            <Route path="indications"          element={<IndicationsPage />} />
            <Route path="changes"              element={<ChangesPage />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
